import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.RequestModule.BulkCreationPopupContent.FileContentType', {
    oneDocumentPerFileButtonTitle: 'One document per file',
    oneDocumentPerFileDescription: 'Each uploaded file is a separate document',
    oneDocumentPerPageButtonTitle: 'One document per page',
    oneDocumentPerPageButtonDescription: 'Each page in the uploaded file is a separate document',
    fileToUploadButtonSectionTitle: 'File type to upload',
});
